import React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../context/TranslationContext';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  const { logout, user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>{t('admin.dashboard.title')}</h2>
          <p>{t('admin.dashboard.welcome', { username: user?.username || '' })}</p>
        </div>
        <nav className="admin-nav">
          <ul>
            <li>
              <Link to="/admin/dashboard" className="nav-link">{t('admin.dashboard.nav.dashboard')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/products" className="nav-link">{t('admin.dashboard.nav.products')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/pickup-locations" className="nav-link">{t('admin.dashboard.nav.pickupLocations')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/orders" className="nav-link">{t('admin.dashboard.nav.orders')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/faqs" className="nav-link">{t('admin.dashboard.nav.faqs')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/admin-users" className="nav-link">{t('admin.dashboard.nav.adminUsers')}</Link>
            </li>
            <li>
              <Link to="/admin/dashboard/profile" className="nav-link">{t('admin.dashboard.nav.profile')}</Link>
            </li>
            <li>
              <Link to="/" className="nav-link">{t('admin.dashboard.nav.mainPage')}</Link>
            </li>
          </ul>
        </nav>
        <button onClick={handleLogout} className="logout-button">
          {t('admin.dashboard.logout')}
        </button>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardPage;
